import ObjectUtils from '../services/object-utils';
import Configs from '../configs';

const APP_ROUTES = {
    homePageRoute: '/',
    comingSoon: '/coming',
    classifiedAds: '/classified-ads',
    mercadoUnicoProducts: Configs.ROUTES.ENABLE_MERCADO_UNICO_PRODUCTS ? '/t/mercado-unico' : null,
    signup: '/signup',
    signin: '/signin',
    sendEmail: '/forgot-password',
    forgot: '/forgot',
    frequentQuestions: '/frequent-questions',
    profile: '/profile',
    taxonomies: '/t/',
    orders: '/orders',
    conversations: '/conversations',
    notifications: '/notifications',
    about: '/about',
    contact: '/contact',
    sitemap: '/site-map',
    faqs: '/faqs',
    terms: '/terms-conditions',
    affidavitCertification: '/affidavit-certification',
    policy: '/privacy-policy',
    returns: '/return-policy',
    shipping: '/shipping-policy',
    offers: '/bids-offers',
    searchPageRoute: '/search',
    cartPageRoute: '/cart',
    wishList: '/wish-list',
    ordersPageRoute: '/orders',
    products: '/products',
    manageKWallet: '/manage-k-wallet',
    addFundsKWallet: '/add-funds-k-wallet',
    checkout: {
        addressPageRoute: '/checkout/address',
        deliveryPageRoute: '/checkout/delivery',
        paymentPageRoute: '/checkout/payment',
        confirmPageRoute: '/checkout/confirm',
        completePageRoute: '/checkout/complete',
        failPageRoute: '/checkout/fail',
        redsysRedirectOk: '/checkout/redsys-ok',
        redsysRedirectKo: '/checkout/redsys-ko',
    },
};

export default ObjectUtils.removeEmptyProperties(APP_ROUTES);



/** WEBPACK FOOTER **
 ** ./src/constants/app-routes.js
 **/